// packages/content/src/assets/characters.ts (M0-T06, §7.4) — the shared character rig (not a catalog id)
import type { AssetBank } from '../schema/assets';

export default { 'rig.mini': { src: 'kit:mini/character-male-a', shadow: 'none' } } satisfies AssetBank;
